import React, { Component } from "react";
import { connect } from "react-redux";

import ReactFileReader from 'react-file-reader';
import Resizer from 'react-image-file-resizer';
import { Select, Input, AsyncSelect } from '../../ui';
import { Title, Body, Text } from '../../Common/Form';
import Continue from "../../Common/Continue";
import { setYatesValue, setClientValue, showError } from "../../../actions";
import { client, options } from "../../../operations";
import { getStreetsAsync } from '../../../operations/options';

import {
  isValidFile,
  imgType,
  mapSelectList
} from '../../../helpers';

import add from '../../../assets/common/add-image.png';
import cross from '../../../assets/common/cross.png';
import iconHouse from '../../../assets/icons/icon-house.svg';

class YateForm_4 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
      fileError: false
    };

    this.continueCondition = this.continueCondition.bind(this);
  }

  componentDidMount() {
    const { getDepartments } = this.props;
    this.checkContinueState(null);
    getDepartments();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState,);
  }

  continueCondition() {

    const {
      file0, file1,
      addressState,
      addressCity,
      addressStreet,
      addressNumber
    } = this.props;

    return (
      file0 !== null &&
      file1 !== null &&
      addressState != null &&
      addressCity != null &&
      addressStreet != null &&
      addressNumber != ''
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getPhotoButton(item, text = "Añadir imagen", optional = false) {

    const { showError, files, onDeleteImage } = this.props;
    const { fileError } = this.state;

    return (
      <div className="Yates-image">
        <ReactFileReader
          handleFiles={(f) => this.handleFiles(item, f, files)}
          fileTypes={['.jpg','.jpeg']}
          base64={true} multipleFiles={false}
        >
          <div className="Yates-image-content">
            <span className="Yates-image-text"> { text } </span>
            { files[item] ?
              <div className="Yates-image-container">
                <img className="Yates-image-preview" src={ files[item].data } alt="preview" />
                <img
                  className="Yates-image-cross" src={cross} alt="delete"
                  onClick={() => {onDeleteImage(files, item)}}
                />
              </div> :
              <div className="Yates-image-button-container">
                <img className={
                  (!optional && (showError || fileError)) ?
                    'Yates-image-button Yates-image-button-error' :
                    'Yates-image-button'
                  }
                  src={ add } alt="add" />
                { optional && <span className="Yates-image-text"> (opcional) </span> }
              </div>
            }
          </div>
        </ReactFileReader>
      </div>
    );
  }

  handleFiles(item, actualFile, files) {

    const { showErrors, onSelectFile } = this.props;

    if (isValidFile(actualFile.fileList[0].type, actualFile.fileList[0].size)) {
      showErrors(false);
      Resizer.imageFileResizer(
        actualFile.fileList[0], 1000, 1000, imgType(actualFile.fileList[0].type), 50, 0, uri =>
        {
          actualFile.base64 = uri;
          files[item] = {
            name: actualFile.fileList[0].name,
            type: actualFile.fileList[0].type,
            data: actualFile.base64
          };
          onSelectFile(files);
        }, 'base64');
    } else {
      this.setState({ fileError: true });
      //showErrors(true);
    }
  }

  getAddressFields = () => {

    const {
      addressState, error, streets,
      onDepartmentChange, departments,
      addressCity, onCityChange,
      cities, addressStreet, showError,
      onClientValueChange, getStreets,
      addressNumber, onStreetChange
    } = this.props;

    return (
      <div>
        <Text style={{ paddingTop: '20px'}} className="Text-question Text-question--bold">
          Datos de dirección
        </Text>

        <div className="Yates-formRow">
          <div style={{ flex: 1 }}>
            <Select
              id="depto"
              leftIcon={iconHouse}
              name="depto"
              value={addressState}
              showAlert={showError && !addressState}
              onChange={onDepartmentChange}
              placeholder="Seleccione un departamento"
              options={mapSelectList(departments)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="city"
              leftIcon={iconHouse}
              name="city"
              value={addressCity}
              showAlert={showError && !addressCity}
              onChange={onCityChange}
              placeholder="Seleccione una ciudad"
              options={mapSelectList(cities)}
              noOptionsMessage={() => "Sin ciudades. Seleccione el Departamento primero."}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="Yates-formRow">
          <div style={{ flex: 1, paddingBottom: '4px' }}>
            <AsyncSelect
              id="address"
              leftIcon={iconHouse}
              name="calle"
              value={addressStreet}
              onChange={onStreetChange}
              placeholder="Seleccione una calle (*)"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={showError && !addressStreet}
              disabled={addressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={addressNumber}
              onChange={(event) => { onClientValueChange('addressNumber', event.target.value) }}
              leftIcon={iconHouse}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />
          </div>
        </div>
      </div>
    );
  }

  getDocumentFields() {

    const {
      continue: toContinue,
      fileError
    } = this.state;
    const {
      filesComments, error,
      file0, file1, file2,
      observaciones,
      onValueChange,
      sendPolicyDocuments
    } = this.props;

    return (
      <div>
        <Text style={{ padding: '10px' }} className="Text-question Text-question--bold">
          Documentos a adjuntar (formato: jpg, jpeg)
        </Text>

        <div className="Yates-imageContainer">
          {this.getPhotoButton(0, filesComments[0])}
          {this.getPhotoButton(1, filesComments[1])}
          {this.getPhotoButton(2, filesComments[2], true)}
        </div>

        { fileError ?
          <div className="Yates-image-text-error">
            {'El documento de identidad y el certificado de matrícula son obligatorios.'} <br/>
            {'Las imagenes a añadir no pueden superar los 5 mb.'} <br/>
            {'Formatos admitidos: .jpg, .jpeg'}
          </div> : null
        }

        <Text style={{ padding: '10px 0px' }} className="Text-question Text-question--bold">
          ¿Quiere declarar una embarcación auxiliar o equipamiento específico?
        </Text>

        <div style={{'padding': '0px 40px 10px 40px'}}>
          <textarea name="observaciones" value={observaciones}
            className='Yates-textarea-input'
            style={{'minHeight': '95px'}}
            onChange={(event) => { onValueChange('observaciones', event.target.value) }}
            placeholder="Campo opcional"
            type="text" maxLength="4000"/>
          <div className="Yates-textarea"
            style={{'textAlign': 'right', 'fontSize': '1.5em', 'paddingRight': '5px'}}>
            {observaciones.length + '/4000'}
          </div>
        </div>

        <Continue state={toContinue} onClick={sendPolicyDocuments} />
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Body columnContent={this.getAddressFields}  />
        {this.getDocumentFields()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.steps.showError,
    showError: state.steps.showError,

    files: state.yates.files,
    file0: state.yates.files[0],
    file1: state.yates.files[1],
    file2: state.yates.files[2],
    filesComments: state.yates.filesComments,

    observaciones: state.yates.observaciones,

    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,

    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setYatesValue(type, value));
    },
    onClientValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    sendPolicyDocuments: () => {
      dispatch(client.sendPolicyDocuments());
    },
    onSelectFile: (value) => {
      dispatch(setYatesValue("files", value));
    },
    onDeleteImage: (files, index) => {
      files[index] = null;
      dispatch(setYatesValue("files", files));
    },
    showErrors: (show) => {
      dispatch(showError(show));
    },
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: (addressCity) => {
      dispatch(options.setCity(addressCity));
    },
    getStreets: (val, callback) => {
      dispatch(options.getStreets(val, callback));
    },
    onStreetChange: (addressStreet) => {
      dispatch(setClientValue('addressStreet', addressStreet));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YateForm_4);